import { AbstractModel } from '../base'
import { Client, Site, type IClient, type ISite } from '../client'
import { AbstractAttachment } from '../common/attachment/attchment'
import { Employee, type IEmployee } from '../employee'
import type {
  IReportObservationAttachment,
  IReportObservationAttachmentData,
  IReportShift,
  IReportShiftData,
  IReportSummary,
  IReportSummaryData
} from './report.types'

export class ReportShift extends AbstractModel implements IReportShift {
  readonly id?: number
  readonly site: number | ISite
  readonly start: Date
  readonly end: Date
  readonly client?: IClient
  readonly guards?: IEmployee[]
  readonly created?: Date
  readonly modified?: Date

  constructor(data: IReportShiftData) {
    super()

    // Validate data
    const requiredFields: (keyof IReportShiftData)[] = ['site', 'start', 'end']
    this.validate(data, requiredFields)

    // Initialize object assuming data valid
    if (data.id) {
      this.id = data.id
    }

    this.site = typeof data.site! === 'number' ? data.site! : new Site(data.site!)
    this.start = typeof data.start! === 'string' ? new Date(data.start!) : data.start!
    this.end = typeof data.end! === 'string' ? new Date(data.end!) : data.end!

    if (data.client) {
      this.client = new Client(data.client)
    }

    if (data.guards) {
      this.guards = data.guards.map((guard) => new Employee(guard))
    }

    if (data.created) {
      this.created = typeof data.created === 'string' ? new Date(data.created) : data.created
    }

    if (data.modified) {
      this.modified = typeof data.modified === 'string' ? new Date(data.modified) : data.modified
    }
  }
}

export class ReportSummary extends AbstractModel implements IReportSummary {
  readonly id?: number
  readonly description: string = ''
  readonly created_by?: string
  readonly modified_by?: string
  readonly created?: Date
  readonly modified?: Date
  readonly owner?: string

  constructor(data: IReportSummaryData) {
    super()

    // Validate data
    const requiredFields: (keyof IReportSummaryData)[] = ['description']
    this.validate(data, requiredFields)

    this.description = data.description!

    if (data.id) {
      this.id = data.id
    }

    if (data.created) {
      this.created = typeof data.created === 'string' ? new Date(data.created) : data.created
    }

    if (data.modified) {
      this.modified = typeof data.modified === 'string' ? new Date(data.modified) : data.modified
    }

    if (data.created_by) {
      this.created_by = data.created_by
    }

    if (data.modified_by) {
      this.modified_by = data.modified_by
    }
  }
}

export class ReportObservationAttachment
  extends AbstractAttachment
  implements IReportObservationAttachment
{
  constructor(data: IReportObservationAttachmentData) {
    super(data)
  }
}
